// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cursor-pointer[data-v-fe15143a]{cursor:pointer}.color-grey[data-v-fe15143a]{color:#656e81}.color-light-grey[data-v-fe15143a]{color:rgba(84,89,94,.6)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
